import { XSign } from '../../../../assets/images/components/NudosComponents';
import { CommentsContent } from '../../../../components/BordComentsAndObservations/components';
import { nudosGray500 } from '../../../../styles/styles.constants';
import { ICommentsAndObservations } from '../../../../types/global';
import { IResponsibleUserData } from '../../../../types/responsibleUser.types';
import './CommentsBox.scss';

const CommentsBox = ({
  comments,
  closeComments,
  handleSubmitComments,
  loading,
  responsibleUsers,
  organizationId
}: {
  comments?: ICommentsAndObservations[];
  closeComments: () => void;
  handleSubmitComments?: (comment: ICommentsAndObservations) => Promise<void>;
  loading: boolean;
  responsibleUsers?: IResponsibleUserData[];
  organizationId: number;
}) => {
  return (
    <div className="commentsBox">
      <div className="headerCommentsBox">
        <p className="title">Chat Interno</p>
        <div className="closeButton" onClick={closeComments}>
          <XSign fill={nudosGray500} />
        </div>
      </div>
      <CommentsContent
        comments={comments}
        handleSubmitComments={handleSubmitComments}
        loading={loading}
        responsibleUsers={responsibleUsers}
        organizationId={organizationId}
      />
    </div>
  );
};

export default CommentsBox;
